
export default {
  name: 'navbarCategories',
  props: {
    titleNavbar: String,
    qaName: String,
    handleClickBackArrow: Function
  }

}
